import SelectBox from "devextreme-react/select-box";
import * as ReportsService from "../../api/reportspost";
import React, { useState, useEffect, useRef } from "react";
import { Button } from "devextreme-react/button";
import DateBox from "devextreme-react/date-box";
import { Toast } from "devextreme-react/toast";
import Popup from "devextreme-react/popup";
import ProgressBar from "devextreme-react/progress-bar";
import ExportJsonExcel from "js-export-excel";
import Moment from "moment";
import "./reportspost.scss";
export default function Reports() {
  const [Clientes, setClientes] = useState([]);
  const [Formularios, setFormularios] = useState([]);
  const [Regiones, setRegiones] = useState([]);
  const [fechaInicial] = useState(
    new Date(new Date().setDate(new Date().getDate() - 7))
  );
  const [FechaFinal, setFechaFinal] = useState(new Date());
  const [Condiciones, setCondiciones] = useState([
    { nombre: "Con Respuestas en blanco", value: "yes" },
    { nombre: "Sin Respuestas en blanco", value: "no" },
  ]);
  const [Opciones, setOpciones] = useState([
    { nombre: "Toda la información", value: "toda" },
    { nombre: "Última sincronización", value: "ultima" },
  ]);
  const initialState = {
    cliente: "",
    formulario: "",
    region: "TODAS LAS REGIONES",
    fechaInicio: new Date(new Date().setDate(new Date().getDate() - 7)),
    fechaFinal: new Date(),
    moneda: "Bs",
    opcion: "toda"
  };
  const [FiltrosReporte, setFiltrosReporte] = useState(initialState);

  const [toastConfig, setToastConfig] = React.useState(
    {
      isVisible: false,
      type: "success",
      message: "Guardado Exitosamente",
      displayTime: 2000,
    },
    []
  );

  const [showProgressPopup, setShowProgressPopup] = useState(false);
  const [progressInfo, setProgressInfo] = useState({
    procesados: 0,
    total: 0,
    faltantes: 0,
  });
  const [isCancelling, setIsCancelling] = useState(false);
  const isCancelledRef = useRef(false);

  const moneda = ["Bs", "$"]

  const columnas = [
    "formulario",
    "fecha_Formulario",
    // "hora_Formulario",
    "fecha_Sincronizado",
    // "hora_Sincronizado",
    "region",
    "region_cliente",
    "cod_externo",
    "usuario",
    "razon_social",
    "canal",
    "ciudad",
    "cod_est",
    "establecimiento",
    "categoria",
    "subcategoria",
    "marcaProducto",
    "codigo",
    "producto",
    "pregunta",
    "respuesta",
    "moneda",
    "tasa",
  ]

  const columnasTodoTicket = []

  const ColumnasTech = [
    "formulario",
    "fecha_Formulario",
    "hora_Formulario",
    "fecha_Creado",
    "hora_Creado",
    "region",
    "usuario",
    "pregunta",
    "respuesta",
  ]

  const columnasSynch = [
    "formulario",
    "fecha_Formulario",
    // "hora_Formulario",
    "fecha_Sincronizado",
    // "hora_Sincronizado",
    "region",
    "usuario",
    "razon_social",
    "canal",
    "ciudad",
    "cod_est",
    "establecimiento",
  ]

  useEffect(() => {
    let user = JSON.parse(localStorage.getItem("userData"));

    // if (user.superAdmin){

    // }

    setClientes(user.cliente);
    setRegiones(user.region);
  }, []);

  const searchFormulario = (e) => {
    if (e.value != "") {
      setFiltrosReporte({ ...FiltrosReporte, cliente: e.value });
      ReportsService.getForms(e.value).then((resp) => {
        setFormularios(resp.data.data);
      });
    }
  };

  // Generar reporte
  const OnSubmit = async () => {

    console.log(FiltrosReporte.opcion)

    const fechaInicialReport = Moment(FiltrosReporte.fechaInicio).format(
      "YYYY-MM-DD"
    );
    const fechaFinalReport = Moment(FiltrosReporte.fechaFinal).format(
      "YYYY-MM-DD"
    );

    const generarReporte = {
      region: FiltrosReporte.region,
      fechaInicio: fechaInicialReport,
      fechaFinal: fechaFinalReport,
      formulario: FiltrosReporte.formulario,
      nombre_Cliente: FiltrosReporte.cliente,
      condicion: FiltrosReporte.condicion ?? "",
      // moneda: FiltrosReporte.moneda,
    };

    if (FiltrosReporte.formulario != "TRANSFERENCIAS") delete generarReporte.condicion

    if (
      generarReporte.nombre_Cliente == "" ||
      generarReporte.nombre_Cliente == undefined
    ) {
      setToastConfig({
        ...toastConfig,
        type: "warning",
        message: "Debe seleccionar un cliente",
        isVisible: true,
      });
      return false;
    }

    if (
      generarReporte.formulario == "" ||
      generarReporte.formulario == undefined
    ) {
      setToastConfig({
        ...toastConfig,
        type: "warning",
        message: "Debe seleccionar un formulario",
        isVisible: true,
      });
      return false;
    }
    if (generarReporte.region == "" || generarReporte.region == undefined) {
      setToastConfig({
        ...toastConfig,
        type: "warning",
        message: "Debe seleccionar una región",
        isVisible: true,
      });
      return false;
    }

    if (generarReporte.region == "TODAS LAS REGIONES") {
      generarReporte.region = undefined
    }

    // Calcular días de diferencia
    const fechaInicio = Moment(fechaInicialReport);
    const fechaFinal = Moment(fechaFinalReport);
    const diasDiferencia = fechaFinal.diff(fechaInicio, 'days') + 1;

    // Crear array de fechas
    const fechas = [];
    for (let i = 0; i < diasDiferencia; i++) {
      const fecha = Moment(fechaInicialReport).add(i, 'days').format("YYYY-MM-DD");
      fechas.push(fecha);
    }

    // Acumulador de resultados
    let todosLosDatos = [];
    let procesados = 0;
    isCancelledRef.current = false;
    setIsCancelling(false);

    // Mostrar popup inicial
    setProgressInfo({
      procesados: 0,
      total: diasDiferencia,
      faltantes: diasDiferencia,
    });
    setShowProgressPopup(true);

    // Procesar cada día
    for (let i = 0; i < fechas.length; i++) {
      // Verificar si se canceló
      if (isCancelledRef.current) {
        // Limpiar datos procesados
        todosLosDatos = [];
        setIsCancelling(false);
        setShowProgressPopup(false);
        setToastConfig({
          ...toastConfig,
          type: "info",
          message: "Proceso cancelado por el usuario",
          isVisible: true,
        });
        return;
      }

      const fechaActual = fechas[i];

      const generarReporteParams = {
        region_name: FiltrosReporte.region,
        fecha_ini: fechaActual,
        fecha_fin: fechaActual,
        form_name: FiltrosReporte.formulario,
        client_name: FiltrosReporte.cliente === 'JORDAN COSMETIC, S.A' ? 'CHOCOLATES KRON, C.A.' : FiltrosReporte.cliente,
        condicion: FiltrosReporte.condicion ?? "",
        last_sync: FiltrosReporte.opcion === "ultima" ? true : false,
        // moneda: FiltrosReporte.moneda,
      };

      if (FiltrosReporte.formulario != "TRANSFERENCIAS") delete generarReporteParams.condicion

      try {
        console.log(generarReporteParams)
        const resp = await ReportsService.generateReports({ params: generarReporteParams });

        if (resp.data && resp.data.length > 0) {
          console.log(resp.data)
          todosLosDatos = [...todosLosDatos, ...resp.data];
        }

        procesados++;
        const faltantes = diasDiferencia - procesados;

        // Actualizar popup de progreso
        setProgressInfo({
          procesados: procesados,
          total: diasDiferencia,
          faltantes: faltantes,
        });
      } catch (error) {
        console.error(`Error procesando fecha ${fechaActual}:`, error);
        procesados++;
        const faltantes = diasDiferencia - procesados;
        setProgressInfo({
          procesados: procesados,
          total: diasDiferencia,
          faltantes: faltantes,
        });
      }
    }

    // Verificar si se canceló antes de procesar resultados
    if (isCancelledRef.current) {
      // Limpiar datos procesados
      todosLosDatos = [];
      setIsCancelling(false);
      setShowProgressPopup(false);
      setToastConfig({
        ...toastConfig,
        type: "info",
        message: "Proceso cancelado por el usuario",
        isVisible: true,
      });
      return;
    }

    // Cerrar popup de progreso
    setShowProgressPopup(false);

    // Si la opción es "ultima", filtrar por formulario y establecimiento (última sincronización)
    if (FiltrosReporte.opcion === "ultima" && todosLosDatos.length > 0) {
      // Agrupar por formulario y establecimiento (cod_est)
      const gruposPorEstablecimiento = {};

      todosLosDatos.forEach(item => {
        const clave = `${item.formulario || ''}_${item.cod_est || ''}`;

        if (!gruposPorEstablecimiento[clave]) {
          gruposPorEstablecimiento[clave] = [];
        }

        gruposPorEstablecimiento[clave].push(item);
      });

      // Para cada grupo, encontrar la fecha más reciente y filtrar
      const datosFiltrados = [];

      Object.keys(gruposPorEstablecimiento).forEach(clave => {
        const grupo = gruposPorEstablecimiento[clave];

        // Obtener todas las fechas únicas de este grupo
        const fechasUnicas = [...new Set(grupo.map(item => {
          if (item.fecha_Formulario) {
            return Moment(item.fecha_Formulario).format("YYYY-MM-DD");
          }
          return null;
        }))].filter(fecha => fecha !== null);

        if (fechasUnicas.length > 0) {
          // Ordenar fechas y obtener la más reciente para este establecimiento
          fechasUnicas.sort((a, b) => Moment(b).diff(Moment(a)));
          const fechaMasReciente = fechasUnicas[0];

          // Filtrar solo los datos del último día para este establecimiento
          const datosDelUltimoDia = grupo.filter(item => {
            if (item.fecha_Formulario) {
              const fechaItem = Moment(item.fecha_Formulario).format("YYYY-MM-DD");
              return fechaItem === fechaMasReciente;
            }
            return false;
          });

          datosFiltrados.push(...datosDelUltimoDia);
        }
      });

      todosLosDatos = datosFiltrados;
    }

    // Procesar y descargar resultados
    if (todosLosDatos.length > 0) {
      console.log("Total de registros:", todosLosDatos.length);

      if (generarReporte.formulario == "Fundamentales" || generarReporte.formulario == "Fundamental" || generarReporte.formulario == "FUNDAMENTAL") {
        let arrayFormPrice = todosLosDatos.filter(x => x.pregunta == "PRECIO")
        let arrayForm = todosLosDatos.filter(x => x.pregunta != "PRECIO")
        console.log(arrayFormPrice)
        console.log(arrayForm)





        exportData(arrayFormPrice, "Precios")
        exportData(arrayForm, "Fundamental")
      } else {
        // Descargar archivo de Excel

        console.log(FiltrosReporte.cliente)
        console.log(FiltrosReporte.formulario)


        if (FiltrosReporte.cliente == "NESTLE VENEZUELA" && FiltrosReporte.formulario == "GIRA Y GANA") {

          // Agrupar registros por todos los campos excepto pregunta y respuesta
          const grupos = {};

          todosLosDatos.forEach(item => {
            // Crear una clave única con todos los campos excepto pregunta y respuesta
            const clave = JSON.stringify({
              formulario: item.formulario,
              fecha_Formulario: item.fecha_Formulario,
              fecha_Sincronizado: item.fecha_Sincronizado,
              region: item.region,
              region_cliente: item.region_cliente,
              cod_externo: item.cod_externo,
              usuario: item.usuario,
              razon_social: item.razon_social,
              canal: item.canal,
              ciudad: item.ciudad,
              cod_est: item.cod_est,
              establecimiento: item.establecimiento,
              categoria: item.categoria,
              subcategoria: item.subcategoria,
              marcaProducto: item.marcaProducto,
              moneda: item.moneda,
              tasa: item.tasa
            });

            if (!grupos[clave]) {
              // Crear el objeto base sin pregunta, respuesta y producto
              grupos[clave] = {
                formulario: item.formulario,
                fecha_Formulario: item.fecha_Formulario,
                fecha_Sincronizado: item.fecha_Sincronizado,
                region: item.region,
                region_cliente: item.region_cliente,
                cod_externo: item.cod_externo,
                usuario: item.usuario,
                razon_social: item.razon_social,
                canal: item.canal,
                ciudad: item.ciudad,
                cod_est: item.cod_est,
                establecimiento: item.establecimiento,
                categoria: item.categoria,
                subcategoria: item.subcategoria,
                marcaProducto: item.marcaProducto,
                moneda: item.moneda,
                tasa: item.tasa
              };
            }

            // Agregar la pregunta como key y la respuesta como value
            grupos[clave][item.pregunta] = item.respuesta;
          });

          // Convertir el objeto de grupos a un array
          const dataNewFormulario = Object.values(grupos);

          console.log(dataNewFormulario);

          exportData(dataNewFormulario, generarReporte.formulario)
        } else {
          exportData(todosLosDatos, generarReporte.formulario)
        }

      }
    } else {
      setToastConfig({
        ...toastConfig,
        type: "warning",
        message: "No se encontraron registro en la fecha dada",
        isVisible: true,
      });
    }




    /*if (generarReporte.formulario == "Levantamiento Kioto"){
      ReportsService.generateReports(generarReporte).then((resp) => {
        if (resp.data.length > 0) {
          console.log(generarReporte)
          console.log(resp.data)
          if (generarReporte.formulario == "Fundamentales" || generarReporte.formulario == "Fundamental" || generarReporte.formulario == "FUNDAMENTAL") {
            let arrayFormPrice = resp.data.filter(x => x.pregunta == "PRECIO")
            let arrayForm = resp.data.filter(x => x.pregunta != "PRECIO")
            console.log(arrayFormPrice)
            console.log(arrayForm)
            exportData(arrayFormPrice, "Precios")
            exportData(arrayForm, "Fundamental")
          } else {
            // Descargar archivo de Excel
            exportData(resp.data, generarReporte.formulario)
          }
        } else {
          setToastConfig({
            ...toastConfig,
            type: "warning",
            message: "No se encontraron registro en la fecha dada",
            isVisible: true,
          });
        }
        // setFiltrosReporte(initialState);
        // setFiltrosReporte({FiltrosReporte, region: "TODAS LAS REGIONES", cliente: "", formulario: "", })
  
  
      });
    } else {
      // ReportsService.generateReportsFormateado(generarReporte).then((resp) => {
        ReportsService.generateReports(generarReporte).then((resp) => {
        if (resp.data.length > 0) {
          console.log(generarReporte)
          console.log(resp.data)
          if (generarReporte.formulario == "Fundamentales" || generarReporte.formulario == "Fundamental" || generarReporte.formulario == "FUNDAMENTAL") {
            let arrayFormPrice = resp.data.filter(x => x.pregunta == "PRECIO")
            let arrayForm = resp.data.filter(x => x.pregunta != "PRECIO")
            console.log(arrayFormPrice)
            console.log(arrayForm)
            exportData(arrayFormPrice, "Precios")
            exportData(arrayForm, "Fundamental")
          } else {
            // Descargar archivo de Excel
            exportData(resp.data, generarReporte.formulario)
          }
        } else {
          setToastConfig({
            ...toastConfig,
            type: "warning",
            message: "No se encontraron registro en la fecha dada",
            isVisible: true,
          });
        }
        // setFiltrosReporte(initialState);
        // setFiltrosReporte({FiltrosReporte, region: "TODAS LAS REGIONES", cliente: "", formulario: "", })
  
  
      });
    }*/

  };

  const exportData = (data, nombre) => {
    let option = {}; // la opción representa el archivo de Excel
    let dataTable = []; // Contenido de datos en archivo Excel
    option.fileName = nombre; // nombre del archivo Excel

    const dataWithLastSync = data.map(item => ({
      ...item,
    }));

    if (nombre == "Sincronizacion") {
      option.datas = [
        {
          sheetData: dataWithLastSync, // Fuente de datos en archivo Excel
          sheetName: nombre, // nombre de la página de hoja en el archivo de Excel
          sheetFilter: columnasSynch,
          sheetHeader: columnasSynch
        },
      ];
    } else if (nombre == "GIRA Y GANA") {
      // Columnas base fijas (sin pregunta, respuesta, producto)
      const columnasBaseGiraYGana = [
        "formulario",
        "fecha_Formulario",
        "fecha_Sincronizado",
        "region",
        "region_cliente",
        "cod_externo",
        "usuario",
        "razon_social",
        "canal",
        "ciudad",
        "cod_est",
        "establecimiento",
        "categoria",
        "subcategoria",
        "marcaProducto",
        "moneda",
        "tasa",
      ];

      // Obtener todas las keys únicas de todos los objetos
      const todasLasKeys = new Set();
      dataWithLastSync.forEach(item => {
        Object.keys(item).forEach(key => {
          todasLasKeys.add(key);
        });
      });

      // Filtrar: mantener solo las keys que NO están en columnasBase y que NO son pregunta/respuesta/producto
      const preguntasDinamicas = Array.from(todasLasKeys).filter(key =>
        !columnasBaseGiraYGana.includes(key) &&
        key !== "pregunta" &&
        key !== "respuesta" &&
        key !== "producto"
      );

      // Ordenar las preguntas dinámicas (opcional: por orden numérico si tienen números)
      preguntasDinamicas.sort((a, b) => {
        // Extraer número del inicio si existe (ej: "01.- ¿PREGUNTA?" -> 1)
        const matchA = a.match(/^(\d+)/);
        const matchB = b.match(/^(\d+)/);
        if (matchA && matchB) {
          return parseInt(matchA[1]) - parseInt(matchB[1]);
        }
        return a.localeCompare(b);
      });

      // Combinar: columnas base + preguntas dinámicas
      const ColumnasGiraYGana = [...columnasBaseGiraYGana, ...preguntasDinamicas];

      option.datas = [
        {
          sheetData: dataWithLastSync, // Fuente de datos en archivo Excel
          sheetName: nombre, // nombre de la página de hoja en el archivo de Excel
          sheetFilter: ColumnasGiraYGana,
          sheetHeader: ColumnasGiraYGana
        },
      ];
    }
    else if (nombre == "Levantamiento Kioto") {
      option.datas = [
        {
          sheetData: dataWithLastSync, // Fuente de datos en archivo Excel
          sheetName: nombre, // nombre de la página de hoja en el archivo de Excel
          sheetFilter: ColumnasTech,
          sheetHeader: ColumnasTech
        },
      ];
    } else if (nombre == "FORMULARIO TODOTICKET" || nombre == "TRANSFERENCIAS") {
      let item = dataWithLastSync[0]
      // console.clear()
      console.log(item)

      const columnasTodoTicket = [];
      for (const prop in item) {
        columnasTodoTicket.push(prop);
      }

      // Definir columnas fijas que deben ir primero en orden específico
      const columnasFijasOrden = [
        "formulario",
        "fecha_Formulario",
        "fecha_Sincronizado",
        "region",
        "usuario",
        "razon_social",
        "canal",
        "ciudad",
        "cod_est",
        "establecimiento",
        "categoria",
        "subcategoria",
        "marcaProducto",
        "producto",
        "moneda",
        "tasa",
      ];

      // Separar columnas fijas y columnas numeradas dinámicas
      const columnasFijas = [];
      const columnasNumericas = [];
      const columnasResto = [];

      columnasTodoTicket.forEach(col => {
        if (columnasFijasOrden.includes(col)) {
          columnasFijas.push(col);
        } else if (/^\d+[A-Z]?\.\s/.test(col)) {
          columnasNumericas.push(col);
        } else {
          columnasResto.push(col);
        }
      });

      // Ordenar las columnas numéricas
      columnasNumericas.sort((a, b) => {
        // Extraer número y posible letra
        const matchA = a.match(/^(\d+)([A-Z]?)\./);
        const matchB = b.match(/^(\d+)([A-Z]?)\./);

        const numA = parseInt(matchA[1], 10);
        const numB = parseInt(matchB[1], 10);
        const letraA = matchA[2] || '';
        const letraB = matchB[2] || '';

        if (numA !== numB) {
          return numA - numB;
        }
        // Si tienen el mismo número, ordenar por letra (A antes que B)
        return letraA.localeCompare(letraB);
      });

      // Combinar en el orden deseado
      const columnasOrdenadas = [
        ...columnasFijas,
        ...columnasNumericas,
        ...columnasResto // si existieran columnas que no son ni fijas ni numeradas
      ];

      // Generar Excel
      option.datas = [
        {
          sheetData: dataWithLastSync,
          sheetName: nombre,
          sheetFilter: columnasOrdenadas,
          sheetHeader: columnasOrdenadas
        },
      ];
      console.log(option.datas)
    } else {
      option.datas = [
        {
          sheetData: dataWithLastSync, // Fuente de datos en archivo Excel
          sheetName: nombre, // nombre de la página de hoja en el archivo de Excel
          sheetFilter: columnas,
          sheetHeader: columnas
        },
      ];
    }
    let toExcel = new ExportJsonExcel(option); // Generar archivo de Excel
    toExcel.saveExcel();
  }

  const onHiding = () => {
    setToastConfig({
      ...toastConfig,
      isVisible: false,
    });
  };

  const [styleMode, setStyleMode] = useState("underlined");
  return (
    <React.Fragment>

      <div className={"content-block dx-card responsive-paddings"}>
        <h5 className={"titleCliente"}>Descarga de Reportes</h5>


        < div style={{ margin: "auto" }}>
          <div className="dx-fieldset">
            <div className="dx">
              <div className="seles">
                <SelectBox
                  className="SelectBoxC mb-4"
                  placeholder="Seleccione un cliente"
                  label="Cliente"
                  searchEnabled={true}
                  dataSource={Clientes}
                  onValueChanged={(e) => searchFormulario(e)}
                  defaultValue={FiltrosReporte.cliente}
                  value={FiltrosReporte.cliente}
                />
              </div>
            </div>

            <div className="dx">
              <div className="">
                <SelectBox
                  className="SelectBoxF mb-4"
                  placeholder="Seleccione un formulario"
                  label="Formulario"
                  labelMode="floating"
                  stylingModes={styleMode}
                  dataSource={Formularios}
                  searchEnabled={true}
                  valueExpr="nombre"
                  displayExpr="nombre"
                  onValueChanged={(e) =>
                    setFiltrosReporte({
                      ...FiltrosReporte,
                      formulario: e.value,
                    })
                  }
                  defaultValue={FiltrosReporte.formulario}
                  value={FiltrosReporte.formulario}
                />
              </div>
            </div>

            {FiltrosReporte.formulario == "TRANSFERENCIAS" && (
              <div className="dx">
                <div className="">
                  <SelectBox
                    className="SelectBoxF mb-4"
                    placeholder="Seleccione Condicion"
                    label="Condicion"
                    labelMode="floating"
                    stylingModes={styleMode}
                    dataSource={Condiciones}
                    searchEnabled={true}
                    valueExpr="value"
                    displayExpr="nombre"
                    onValueChanged={(e) =>
                      setFiltrosReporte({
                        ...FiltrosReporte,
                        condicion: e.value,
                      })
                    }
                    defaultValue={FiltrosReporte.condicion}
                    value={FiltrosReporte.condicion}
                  />
                </div>
              </div>
            )}
            {/* 
            {(FiltrosReporte.cliente == "PUIG" || FiltrosReporte.cliente == "MULTI BRANDS, C.A") && (FiltrosReporte.formulario == "Fundamental" || FiltrosReporte.formulario == "Fundamentales" || FiltrosReporte.formulario == "FUNDAMENTAL") && ( */}
            <div className="dx">
              <div className="">
                <SelectBox
                  className="SelectBoxF mb-4"
                  placeholder="Seleccione una opción"
                  label="Opciones"
                  labelMode="floating"
                  stylingModes={styleMode}
                  dataSource={Opciones}
                  searchEnabled={true}
                  valueExpr="value"
                  displayExpr="nombre"
                  onValueChanged={(e) =>
                    setFiltrosReporte({
                      ...FiltrosReporte,
                      opcion: e.value,
                    })
                  }
                  defaultValue={FiltrosReporte.opcion}
                  value={FiltrosReporte.opcion}
                />
              </div>
            </div>
            {/* )} */}

            <div className="dx">
              <div className="">
                <SelectBox
                  className="SelectBoxR mb-4"
                  placeholder="Seleccione una región"
                  label="Región"
                  dataSource={Regiones}
                  searchEnabled={true}
                  // valueExpr="nombre_region"
                  // displayExpr="nombre_region"
                  onValueChanged={(e) =>
                    setFiltrosReporte({ ...FiltrosReporte, region: e.value })
                  }
                  defaultValue={FiltrosReporte.region}
                  value={FiltrosReporte.region}
                  style={{}}
                />
              </div>
            </div>
            {/* <div className="dx">
            <div className="">
              <SelectBox
                className="SelectBoxR mb-4"
                placeholder="Seleccione una región"
                label="Moneda"
                dataSource={moneda}
                searchEnabled={true}
                // valueExpr="nombre_region"
                // displayExpr="nombre_region"
                onValueChanged={(e) =>
                  setFiltrosReporte({ ...FiltrosReporte, moneda: e.value })
                }
                defaultValue={FiltrosReporte.moneda}
                value={FiltrosReporte.moneda}
                style={{}}
              />
            </div>
          </div> */}

            <div className="dx">
              <div className="">
                <DateBox
                  className="SelectBoxDate mb-4"
                  placeholder="Fecha de reporte desde"
                  label="Desde"
                  onValueChanged={(e) =>
                    setFiltrosReporte({
                      ...FiltrosReporte,
                      fechaInicio: e.value,
                    })
                  }
                  defaultValue={fechaInicial}
                  value={fechaInicial}
                  type="date"
                />
              </div>
            </div>

            <div className="dx">
              <div className="">
                <DateBox
                  className="SelectBoxDate mb-4"
                  placeholder="Fecha de reporte hasta"
                  label="Hasta"
                  onValueChanged={(e) =>
                    setFiltrosReporte({
                      ...FiltrosReporte,
                      fechaFinal: e.value,
                    })
                  }
                  defaultValue={FechaFinal}
                  value={FechaFinal}
                  type="date"
                />
              </div>
            </div>
          </div>
          <div className="BTN">
            <Button
              className="btnGenerarReporte"
              variant="contained"
              onClick={() => OnSubmit()}
              size="large"
            >
              Generar reporte
            </Button>
          </div>
        </div>



        <Popup
          visible={showProgressPopup}
          showTitle={true}
          title="Generando Reporte"
          showCloseButton={false}
          width={550}
          height={480}
          dragEnabled={false}
          className="progress-popup"
        >
          <div className="progress-popup-content">
            <div className="progress-icon-container">
              <div className="progress-spinner"></div>
            </div>
            <h3 className="progress-title">
              Procesando datos...
            </h3>
            <div className="progress-stats">
              <div className="progress-stat-item">
                <span className="progress-stat-number">{progressInfo.procesados}</span>
                <span className="progress-stat-label">de {progressInfo.total} días procesados</span>
              </div>
              <div className="progress-stat-item">
                <span className="progress-stat-remaining">{progressInfo.faltantes}</span>
                <span className="progress-stat-label">días restantes</span>
              </div>
            </div>
            <div className="progress-bar-container">
              <ProgressBar
                id="progress-bar"
                min={0}
                max={progressInfo.total}
                value={progressInfo.procesados}
                showStatus={false}
                width="100%"
                className="custom-progress-bar"
              />
              <div className="progress-percentage">
                {progressInfo.total > 0 ? Math.round((progressInfo.procesados / progressInfo.total) * 100) : 0}%
              </div>
            </div>
            <div className="progress-cancel-button">
              <Button
                text="Cancelar"
                type="danger"
                onClick={() => {
                  isCancelledRef.current = true;
                  setIsCancelling(true);
                }}
                className="btn-cancel-progress"
                disabled={isCancelling}
              />
              {isCancelling && (
                <div className="cancelling-label">
                  Cancelando...
                </div>
              )}
            </div>
          </div>
        </Popup>

        <Toast
          visible={toastConfig.isVisible}
          message={toastConfig.message}
          type={toastConfig.type}
          onHiding={onHiding}
          displayTime={toastConfig.displayTime}
        />
      </div>
    </React.Fragment>
  );
}
